import { render, staticRenderFns } from "./DiscussionCategories.vue?vue&type=template&id=5cebcda2&"
import script from "./DiscussionCategories.vue?vue&type=script&lang=js&"
export * from "./DiscussionCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports